import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BottomNavMobile.css';

export default function BottomNavMobile() {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="mobile-bottom-nav">
            <div 
                className={`mobile-nav-item ${location.pathname === '/doctor' ? 'active' : ''}`} 
                onClick={() => navigate('/doctor')}
            >
                {/* أيقونة المستخدم */}
                <i className={location.pathname === '/doctor' ? "fa-solid fa-user-circle" : "fa-regular fa-user-circle"}></i>
            </div>

            <div 
                className={`mobile-nav-item ${location.pathname === '/Main' ? 'active' : ''}`} 
                onClick={() => navigate('/Main')}
            >
                {/* أيقونة المنزل */}
                <i className={location.pathname === '/Main' ? "fa-solid fa-house" : "fa-solid fa-house" /* في FontAwesome 6 الـ House غالباً Solid فقط، لكن يمكنك التعديل إذا كنت تستخدم مكتبة أخرى */}></i>
            </div>

            <div 
                className={`mobile-nav-item ${location.pathname === '/support' ? 'active' : ''}`} 
                onClick={() => navigate('/support')}
            >
                {/* أيقونة الدعم */}
                <i className={location.pathname === '/support' ? "fa-solid fa-headset" : "fa-solid fa-headset"}></i>
            </div>
        </div>
    );
}